import React from 'react'
import Font from '@cred/react-font'
import styles from './styles.module.scss'

const disclaimers = (slug, vertical, apy) => {
  const hysDisclaimers = {
    high_yield_savings: {
      wealthfront: (
        <>
          <Font type="disclaimer" weight="bold">
            Details
          </Font>
          <br />
          <Font type="disclaimer">Earn {apy}% with a $1 minimum deposit.</Font>
          <br />
          <Font type="disclaimer" weight="bold">
            Disclosure
          </Font>
          <br />
          <Font type="disclaimer">
            Credible Lab’s receives cash compensation for referring potential clients to Wealthfront
            Advisers, LLC (“Wealthfront Advisers”) via advertisements placed on their website.
            Credible Lab’s and Wealthfront Advisers are not affiliated with one another and have no
            formal relationship outside of the solicitation arrangement.
            <br />
            <br />
            Cash account is offered by Wealthfront Brokerage LLC, member of FINRA/SIPC. Wealthfront
            Brokerage is not a bank. We convey funds to partner banks who accept and maintain
            deposits, provide the interest rate, and provide FDIC insurance. Rate is subject to
            change.
          </Font>
          <br />
        </>
      ),
      nationwide: (
        <>
          <Font type="disclaimer" weight="bold">
            Details
          </Font>
          <br />
          <Font type="disclaimer">
            Earn up to {apy}% with My Savings when you open a Nationwide My Checking account and set
            up a $1,000 direct deposit. If you do not wish to pen a My Checking Account, you can
            still earn 0.40% APY with a My Savings account, a la carte. No minimum balance
            requirements, no maintenance fees, and interest compounded daily.
          </Font>
          <br />
        </>
      ),
      discover: (
        <>
          <Font type="disclaimer" weight="bold">
            Details
          </Font>
          <br />
          <Font type="disclaimer">Earn {apy}% with no minimum deposit required.</Font>
          <br />
        </>
      ),
      amex: (
        <>
          <Font type="disclaimer" weight="bold">
            Details
          </Font>
          <br />
          <Font type="disclaimer">$0 minimum deposit and minimum balance.</Font>
          <br />
        </>
      ),
    },
    interest_checking: {
      axosdirect: (
        <>
          <Font type="disclaimer" weight="bold">
            Details
          </Font>
          <br />
          <Font type="disclaimer">
            Earn up to {apy}% based on the following combined rate rewards:
          </Font>
          <br />
          <ul className={styles.list}>
            <Font type="disclaimer" element="li">
              Direct deposits (not including intra-bank transfers from another account) totaling
              $1,000 or more each month will earn .4166%
            </Font>
            <br />
            <Font type="disclaimer" element="li">
              At least ten (10) point-of-sale transactions per month using your Rewards Checking
              Visa Debit Card for normal everyday purchases with a minimum of $3 per transaction
              will earn .4166%
            </Font>
            <br />
            <Font type="disclaimer" element="li">
              Adding five (5) or more point-of-sale transactions per month using your Rewards
              Checking Visa Debit Card for normal everyday purchases with a minimum of $3 per
              transaction will earn .4166%
            </Font>
          </ul>
        </>
      ),
    },
  }

  return hysDisclaimers[vertical][slug]
}

export { disclaimers }
export default disclaimers
